import React, { FC } from "react";

import { useHeaderMenu } from "../../../../../hooks/use-header-menu";
import { LogoutButton } from "../../../common/logout-button";
import { UserGreeting } from "../../../common/user-greeting";
import { HeaderMenuItemDetailTitle } from "../../header-menu-item-detail-title";

export interface PersonalAreaAuthenticatedProps {}

export const PersonalAreaAuthenticated: FC<PersonalAreaAuthenticatedProps> = ({}) => {
  const { labels } = useHeaderMenu();

  return (
    <div className="flex flex-col gap-4">
      <HeaderMenuItemDetailTitle
        titleClassName="text-primary"
        title={labels["header-menu-personal-area-authenticated-title"]}
      />
      <UserGreeting />
      <p className="font-light">{labels["header-menu-personal-area-authenticated-body"]}</p>
      <LogoutButton />
    </div>
  );
};
